import React, {useState, useContext} from 'react';
// import { NavLink } from 'react-router-dom';
import {Button, Tooltip} from 'reactstrap';
import {useHistory, useLocation} from 'react-router-dom';
import queryString from 'query-string';
import {DateTime} from "luxon";
import {useIntl} from 'react-intl';
import {useSubscription, gql} from '@apollo/client';

import EventContext from '../contexts/event';
import UserContext from '../contexts/user';
import Footer from './footer';
import getEncodedImageUrl from '../helpers/get-encoded-image';
import {BackArrow} from './svgs'
import {Presentation} from '../types/presentation';
import {InLinePreLoader} from '../components/preloader';

import {secondsToTime} from '../helpers';

const SidebarQuizWithLeaderBoard: React.FC<{
    presentation: Presentation;
}> = ({presentation}) => {
    const eventContext = useContext(EventContext);
    const userContext = useContext(UserContext);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(s => !s);

    const location = useLocation();
    const [isVirtual] = useState(queryString.parse(location.search).viewmode === "virtual");
    const intl = useIntl();
    const history = useHistory();
    // const [showDropdown, setShowDropdown] = useState(false);

    // const toggleDropdown = () => {
    //   setShowDropdown(!showDropdown)
    // }

    // return <pre>WIP</pre>


    const {data, loading} = useSubscription<{
        leaderboard: Array<{
            user: {
                id: string;
                photo: string;
                name: string;
            }
            points: number;
        }>
    }>(gql`
    subscription (
      $presentation_id: String!
    ) {
      leaderboard (where: {
        presentation_id: {
          _eq: $presentation_id
        }
      }, order_by: {
        points: desc
      }) {
        user {
          id
          photo
          name
        }
        points
      }
    }
  `, {
        variables: {
            presentation_id: presentation._id,
        }
    })

     console.log("SidebarQuizWithLeaderBoard", data)
     console.log("SidebarQuizWithLeaderBoard", loading, !data)
     console.log("SidebarQuizWithLeaderBoard", presentation._id)

    if (loading || !data) {
        return <InLinePreLoader/>
    }

    if (!presentation) {
        return <div/>
    }

    const textPositions = ['first', 'second', 'third'];
    const currentUserPosition = data.leaderboard.findIndex(leader => leader.user?.id === userContext.user?.id);


    function limitChars(text: string, count: number) {
        return (
            <React.Fragment>
                {
                    text.length > count ?
                        <React.Fragment>
                            <span id="NameTooltip">{text.slice(0, count) + (text.length > count ? "..." : "")}</span>
                            <Tooltip placement="top" isOpen={tooltipOpen} autohide={false} target="NameTooltip"
                                     toggle={toggle}>
                                {text}
                            </Tooltip>
                        </React.Fragment>
                        :
                        <span>{text}</span>
                }
            </React.Fragment>
        )
    }

    return (
        <div className="sidebar-main quiz-user">
            <div className="logo-container">
                {/* <img src="/images/logoplaceholder.png" alt="logo" /> */}
                <span className="day">
          {!isVirtual && <span className="day-text">DAY {presentation.day}</span>}
                    <span className="useless-line"></span>
                    {!isVirtual && presentation.date && <span
                        className="date">{DateTime.fromFormat(presentation.date, 'yyyy-MM-dd').toFormat('D')}</span>}
        </span>
                <h6>{presentation.name}</h6>
                <div className="speaker-deails-sidebar">
                    {
                        presentation.speaker_info && presentation.speaker_info.picture ? <img
                            src={getEncodedImageUrl(presentation.speaker_info && presentation.speaker_info.picture, 56, 56)}
                            alt="speaker"/> : <img src="/images/plimgspeaker.png" alt="speaker"/>
                    }
                    <div>
                        <p>{presentation.speaker_info && presentation.speaker_info.title} {presentation.speaker_info && presentation.speaker_info.firstName} {presentation.speaker_info && presentation.speaker_info.lastName}</p>
                        {
                            !isVirtual &&
                            presentation.time &&
                            presentation.end_time &&
                            <span className="time-room-container">
                {secondsToTime(presentation.time)} - {secondsToTime(presentation.end_time)}
                                <span
                                    className="room-name">{presentation.room_info && presentation.room_info.name}</span>
              </span>
                        }
                    </div>
                </div>
                <div className="back-link m-t-30">
                    <Button onClick={() => history.push(`/${eventContext.slug}${document.location.search}`)}
                            color="link"><BackArrow/>{intl.formatMessage({id: 'button.common.back'})}</Button>
                </div>
            </div>
            <div className="nav-conatiner nav-result-container calc-nav-height quiz-side-res-mob-fix">
                <div className="podium-container">
                    <div className="podium-main">
                        <div className="podium-results-container m-t-60">
                            <div className="d-block">
                                {
                                    currentUserPosition > -1 &&
                                    <div className="your-position">
                    <span>{intl.formatMessage({id: 'sidebar.you.are.the'})} <strong>{currentUserPosition + 1}<sup>{
                        currentUserPosition + 1 === 1
                            ? intl.formatMessage({id: 'st'})
                            : currentUserPosition + 1 === 2
                                ? intl.formatMessage({id: 'nd'})
                                : currentUserPosition + 1 === 3
                                    ? intl.formatMessage({id: 'rd'})
                                    : intl.formatMessage({id: 'th'})
                    }</sup></strong>,</span>
                                        <span className="points"> &nbsp; {intl.formatMessage({id: 'with'})} &nbsp;
                                            <strong>{data.leaderboard[currentUserPosition].points} {intl.formatMessage({id: 'points'})}</strong></span>
                                    </div>
                                }
                            </div>
                            <div className="d-block">
                                <div className="mobile-stage-container">
                                    {
                                        data.leaderboard.slice(0, 3).map((leader, index) => {
                                             console.log("mobile-stage", leader)

                                            return <div key={leader.user.id} className={`score-details ${textPositions[index]}`}>
                      <span className="stand">

                        {
                            leader?.user?.photo ? (
                                <span className="user-image">
                          <img src={getEncodedImageUrl(leader.user.photo, 48, 48)
                          } alt={leader.user.name}/>
                        </span>
                            ) : (<span className="user-image">
                         <img
                             src="/images/placeholder.svg"
                             className="rounded profileImage"
                             width="50"
                         />
                        </span>)

                        }
                      </span>
                                                <span className="score">
                       <span> {leader.user.name}</span>
                       <span>+ {leader.points}</span>
                      </span>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            data.leaderboard.length > 3 &&
                            <div className="remaining-results m-t-40">
                                <ul>
                                    {
                                        data.leaderboard.slice(3).map((leader, index) => <li key={leader.user.id}>
                                            <span>{index + 4}/{leader.user.name}<span>+ {leader.points}</span></span>
                                        </li>)
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default SidebarQuizWithLeaderBoard;
